module.exports = __webpack_public_path__ + "img/palmar-room-7A.f152e1f7.jpg";